import React from 'react';
import {RootState} from "../../../../../../reducers";
import {getCart} from "../../../../../services/Cart/reducer";
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {OrderType} from "../../../../../services/Api/types";
import {getStoreConfig} from "../../../../../services/Store/reducer";
import {ReactComponent as CarSVG} from "../../../../../../images/icons/car.svg";

interface OwnProps {
    loading: boolean;
    orderType: OrderType;
    handleChangeType: (
        event: any,
        value?: string,
    ) => Promise<void>;
    handleOnTypeLabelKeyDown: (
        orderType: string,
    ) => (event: (React.KeyboardEvent<HTMLLabelElement> | KeyboardEvent)) => Promise<void>;
    drawOpenHours: (
        orderType: OrderType,
    ) => JSX.Element;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const CartPageDeliveryOption = ({
                                    handleOnTypeLabelKeyDown,
                                    cart,
                                    loading,
                                    orderType,
                                    handleChangeType,
                                    config,
                                    drawOpenHours
                                }: Props) => {
    const {t} = useTranslation();
    const checked = orderType === OrderType.DELIVERY;

    if (config?.ordering.delivery || orderType === OrderType.DELIVERY) {
        return (
            <label
                className={`btn btn-default btn-lg btn-check-full btn-spinner${(cart.pending || loading) ? " loading" : ""}${orderType === OrderType.DELIVERY ? " active" : ""}`}
                onKeyDown={handleOnTypeLabelKeyDown(OrderType.DELIVERY)} tabIndex={0} aria-checked={checked}>
                <CarSVG/>
                <span>
                    <p className="mb-0">{t("enums.order.type.DELIVERY")}</p>
                    {drawOpenHours(OrderType.DELIVERY)}
                </span>
                <input className="btn-check1" type="radio" name="type" value={OrderType.DELIVERY} autoComplete="off"
                       tabIndex={-1} checked={checked} onChange={handleChangeType}/>
                <div className="spinner-border spinner-border-sm"/>
            </label>
        )
    }

    return <></>;
}

const mapStateToProps = (state: RootState) => ({
    cart: getCart(state.cart),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartPageDeliveryOption));
